/**
 * Operator portal rework PR 5 — the banner on every portal page while a Paelode admin is viewing
 * as an operator user: whose view, read-only, until when, and End.
 */

import React from 'react';
import { useApiOpts, roleDisplayLabel } from '@lodex-pro/web-shared';
import { endViewAs, type ViewAsSession } from '../auth/view-as';

function timeOf(iso: string): string {
  return new Date(iso).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
}

export function ViewAsBanner({ session }: { readonly session: ViewAsSession }): React.JSX.Element {
  const apiOpts = useApiOpts();
  const role = roleDisplayLabel(session.role);
  const who = `${session.targetName ?? 'a user'}${role !== null ? ` (${role})` : ''}`;
  return (
    <div
      role="status"
      aria-label="Viewing as"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        padding: '8px 24px',
        background: 'rgba(246, 182, 94, 0.14)',
        color: 'var(--color-warning)',
        fontSize: '13px',
      }}
    >
      <span>
        Viewing <strong>{session.operatorName}</strong> as <strong>{who}</strong>. Read-only; ends
        at {timeOf(session.expiresAt)}.
      </span>
      <button
        type="button"
        onClick={(): void => {
          void endViewAs(apiOpts);
        }}
        style={{
          padding: '4px 12px',
          cursor: 'pointer',
          background: 'rgba(246, 182, 94, 0.14)',
          color: 'var(--color-warning)',
          border: 'none',
          borderRadius: 'var(--radius-pill)',
          fontSize: '13px',
          fontWeight: 600,
        }}
      >
        End view
      </button>
    </div>
  );
}
